import { useEffect, useMemo } from "react";
import { useStore } from "ra-core";

import type { DealStage, LabeledValue, NoteStatus } from "../types";
import { defaultConfiguration } from "./defaultConfiguration";

export const CONFIGURATION_STORE_KEY = "app.configuration";
export const CURRENT_CONFIG_VERSION = 2;

export interface ConfigurationContextValue {
  configVersion?: number;
  allowInitialSignup?: boolean;
  companySectors: LabeledValue[];
  currency: string;
  dealCategories: LabeledValue[];
  dealPipelineStatuses: string[];
  dealStages: DealStage[];
  noteStatuses: NoteStatus[];
  taskTypes: LabeledValue[];
  title: string;
  darkModeLogo: string;
  lightModeLogo: string;
  googleWorkplaceDomain?: string;
  disableEmailPasswordAuthentication?: boolean;
}

export const useConfigurationContext = () => {
  const [config, setConfig] = useStore<ConfigurationContextValue>(
    CONFIGURATION_STORE_KEY,
    defaultConfiguration,
  );

  // Reset stale localStorage config when version doesn't match current defaults
  useEffect(() => {
    if (config?.configVersion !== CURRENT_CONFIG_VERSION) {
      setConfig(defaultConfiguration);
    }
  }, [config, setConfig]);

  return useMemo(() => {
    if (config?.configVersion !== CURRENT_CONFIG_VERSION) {
      return defaultConfiguration;
    }
    return { ...defaultConfiguration, ...config };
  }, [config]);
};

export const useConfigurationUpdater = () => {
  const [, setConfig] = useStore<ConfigurationContextValue>(
    CONFIGURATION_STORE_KEY,
  );
  return setConfig;
};
